/**
 * fiftyday-media-signup — newsletter sin recarga. Envío interceptado en window **y**
 * document (capture) más el propio `<form>`; así se adelanta a delegados del tema sobre `body`. */
(function () {
  var POST_QUERY_KEYS_TRUE = ['posted_successfully', 'customer_posted', 'contact_posted', 'posted'];
  var DOC_BOUND = 'fiftydayMsSubmitCapture';
  /** Breve espera antes de mostrar mensaje configurado en el tema */
  var SUCCESS_REVEAL_MS = 520;
  function escapeRe(s) {
    return String(s || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function parseEmbeddedNewsletterJson(html, sectionId) {
    if (typeof html !== 'string' || !sectionId) return null;
    var sid = 'fiftyday-ms-xhr-' + escapeRe(sectionId);
    var patterns = [
      new RegExp(
        '<script[^>]*\\sid=["\']' + sid + '["\'][^>]*type=["\']application\\/json["\'][^>]*>([\\s\\S]*?)<\\/script>',
        'i'
      ),
      new RegExp(
        '<script[^>]*type=["\']application\\/json["\'][^>]*\\sid=["\']' + sid + '["\'][^>]*>([\\s\\S]*?)<\\/script>',
        'i'
      ),
    ];
    for (var pi = 0; pi < patterns.length; pi++) {
      var m = html.match(patterns[pi]);
      if (!m || !m[1]) continue;
      try {
        return JSON.parse(m[1].trim());
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function domIndicatesSignupSuccess(html, sectionId) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var successEl = doc.getElementById('fiftyday-ms-success-' + sectionId);
      var fieldsEl = doc.getElementById('fiftyday-ms-fields-' + sectionId);
      if (!successEl || !fieldsEl) return false;
      return !successEl.hasAttribute('hidden') && fieldsEl.hasAttribute('hidden');
    } catch (e) {
      return false;
    }
  }

  function legacyUrlOrBodyHints(responseUrl, responseText, sectionId) {
    var txt = responseText || '';
    var marker = sectionId ? 'data-fiftyday-ms-submit="success-' + sectionId + '"' : '';

    if (marker && txt.indexOf(marker) !== -1) return true;

    if (
      txt.indexOf('posted_successfully=true') !== -1 &&
      txt.indexOf('fiftyday-ms__dialog') !== -1 &&
      txt.indexOf('fiftyday-ms__form') !== -1
    ) {
      return true;
    }

    if (!responseUrl) return false;

    try {
      var u = new URL(responseUrl, window.location.origin);
      for (var i = 0; i < POST_QUERY_KEYS_TRUE.length; i++) {
        if (u.searchParams.get(POST_QUERY_KEYS_TRUE[i]) === 'true') return true;
      }
    } catch (e) {}

    if (responseUrl.indexOf('posted_successfully=true') !== -1) return true;
    if (responseUrl.indexOf('customer_posted=true') !== -1) return true;
    if (responseUrl.indexOf('contact_posted=true') !== -1) return true;

    return false;
  }

  function isOverallSuccess(html, finalUrl, sectionId) {
    if (domIndicatesSignupSuccess(html, sectionId)) return true;
    var j = parseEmbeddedNewsletterJson(html, sectionId);
    if (j && j.posted === true) return true;
    return legacyUrlOrBodyHints(finalUrl, html, sectionId);
  }

  function applyRenderedErrors(sectionId, html, errNote) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.getElementById('fiftyday-ms-err-' + sectionId);
      if (!src || !errNote) return;
      errNote.innerHTML = src.innerHTML;
      errNote.removeAttribute('hidden');
    } catch (e) {}
  }

  function hideErrors(errNote) {
    if (!errNote) return;
    errNote.setAttribute('hidden', '');
    errNote.innerHTML = '';
  }

  function endLoading(form, btn) {
    try {
      delete form.dataset.fiftydayMsSending;
    } catch (e2) {}
    form.setAttribute('aria-busy', 'false');
    if (btn) btn.disabled = false;
  }

  function showSuccessState(form, fieldBlock, successBlock, errNote, btn) {
    hideErrors(errNote);
    if (fieldBlock) fieldBlock.setAttribute('hidden', '');
    if (successBlock) {
      successBlock.removeAttribute('hidden');
      try {
        successBlock.focus({ preventScroll: true });
      } catch (e1) {
        successBlock.focus();
      }
    }
    endLoading(form, btn || form.querySelector('button[type="submit"]'));
  }

  function resolvePostUrl(form) {
    try {
      var raw = form.getAttribute('action');
      if (!raw || !String(raw).trim()) raw = '/contact';
      return new URL(raw, document.baseURI || window.location.href).href;
    } catch (e7) {
      try {
        return form.action || String(window.location.origin) + '/contact';
      } catch (e8) {
        return '/contact';
      }
    }
  }

  /**
   * NUNCA pisar return_to con window.location en preview/customizer/iframes: suele ser "/" o dominio equivocado.
   * Shopify sólo diferencia rutas mediante return_to; el POST es el mismo /contact para landing y footer.
   */
  function patchReturnToCurrentUrl(form) {
    try {
      var inp =
        form.querySelector('input[name="return_to"][data-fiftyday-ms-return]') || form.querySelector('input[name="return_to"]');
      if (!inp) return;
      var canonical = inp.getAttribute('data-fiftyday-canonical-return');
      if (canonical && String(canonical).trim()) {
        inp.value = canonical.trim();
        return;
      }
      /** Sin dato Liquid: conservar valor renderizado; no usar location */
    } catch (eR) {}
  }

  function scheduleSuccessReveal(form, fieldBlock, successBlock, errNote, btn) {
    try {
      clearTimeout(form._fiftydayMsRevealT);
    } catch (eT) {}
    form._fiftydayMsRevealT = setTimeout(function () {
      try {
        delete form._fiftydayMsRevealT;
      } catch (eD) {}
      showSuccessState(form, fieldBlock, successBlock, errNote, btn);
    }, SUCCESS_REVEAL_MS);
  }

  function onSubmitCapture(ev) {
    var form = ev.target;
    if (!form || String(form.tagName).toUpperCase() !== 'FORM') return;
    /** Drop grid (fsldg) usa el mismo markup de tema pero otro listener */
    if (form.classList && form.classList.contains('fsldg-ms__form')) return;
    if (!form.classList || !form.classList.contains('fiftyday-ms__form')) return;

    var dlg = typeof form.closest === 'function' ? form.closest('dialog') : null;
    if (!dlg || dlg.id.indexOf('fiftyday-ms-dialog-') !== 0) return;

    var sid = dlg.id.replace(/^fiftyday-ms-dialog-/, '');
    var fieldBlock = document.getElementById('fiftyday-ms-fields-' + sid);
    var successBlock = document.getElementById('fiftyday-ms-success-' + sid);

    /** Si algo no coincide con el Liquid, no interceptar: navegador hace POST normal */
    if (!fieldBlock || !successBlock) return;

    if (!form.reportValidity()) return;

    ev.preventDefault();

    if (form.dataset.fiftydayMsSending === '1') {
      return;
    }
    /** No stopImmediatePropagation para no romper otros scripts del tema. */

    var errNote = form.querySelector('.fiftyday-ms__form-notification.error');

    try {
      try {
        clearTimeout(form._fiftydayMsRevealT);
      } catch (eC) {}

      form.dataset.fiftydayMsSending = '1';

      hideErrors(errNote);

      patchReturnToCurrentUrl(form);

      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      form.setAttribute('aria-busy', 'true');

      var actionHref = resolvePostUrl(form);

      fetch(actionHref, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'follow',
        headers: {
          Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
        },
      })
        .then(function (response) {
          return response.text().then(function (text) {
            return {
              ok: response.ok,
              status: response.status,
              url: response.url || '',
              text: text,
            };
          });
        })
        .then(function (bundle) {
          var txt = bundle.text || '';

          if (bundle.status === 429 || bundle.status >= 500) {
            endLoading(form, btn);
            return;
          }

          if (isOverallSuccess(txt, bundle.url, sid)) {
            scheduleSuccessReveal(form, fieldBlock, successBlock, errNote, btn);
            return;
          }

          var meta = parseEmbeddedNewsletterJson(txt, sid);
          if (meta && meta.hasErrors === true) {
            applyRenderedErrors(sid, txt, errNote);
            endLoading(form, btn);
            return;
          }

          if (
            txt.indexOf('/challenge') !== -1 ||
            txt.indexOf('ShopifyCaptcha') !== -1 ||
            txt.indexOf('g-recaptcha') !== -1
          ) {
            endLoading(form, btn);
            return;
          }

          endLoading(form, btn);
        })
        .catch(function () {
          endLoading(form, btn);
        });
    } catch (e3) {
      endLoading(form, form.querySelector('button[type="submit"]'));
    }
  }

  function bindFiftydayMsSubmitCaptureOnce() {
    var root = document.documentElement;
    if (!root || root.dataset[DOC_BOUND] === '1') return;
    root.dataset[DOC_BOUND] = '1';
    window.addEventListener('submit', onSubmitCapture, true);
    document.addEventListener('submit', onSubmitCapture, true);
  }

  bindFiftydayMsSubmitCaptureOnce();

  function initRoot(root) {
    if (root.dataset.fiftydayMsInited === '1') return;
    root.dataset.fiftydayMsInited = '1';
    var sid = root.id.replace(/^fiftyday-ms-root-/, '');
    var dlg = document.getElementById('fiftyday-ms-dialog-' + sid);
    if (!dlg) return;

    var opener = root.querySelector('[data-fiftyday-ms-open]');
    var closer = dlg.querySelector('[data-fiftyday-ms-close]');

    var successBlock = document.getElementById('fiftyday-ms-success-' + sid);
    var formInside = dlg.querySelector('form.fiftyday-ms__form');

    if (formInside) {
      patchReturnToCurrentUrl(formInside);
      formInside.addEventListener('submit', onSubmitCapture, true);
    }

    if (successBlock && !successBlock.hasAttribute('hidden') && typeof dlg.showModal === 'function') {
      dlg.showModal();
    }

    if (opener && typeof dlg.showModal === 'function') {
      opener.addEventListener('click', function () {
        if (formInside) patchReturnToCurrentUrl(formInside);
        dlg.showModal();
      });
    }
    if (closer) {
      closer.addEventListener('click', function () {
        dlg.close();
      });
    }
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) dlg.close();
    });
  }

  function scan() {
    document.querySelectorAll('[id^="fiftyday-ms-root-"]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /** Customizer / secciones inyectadas tras el load */
  document.addEventListener('shopify:section:load', scan);
})();
